import { ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA } from '../types';

export default function alterarRegistrosPorPaginaSelecaoEmpresa(valor) {
  return {
    type: ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA,
    payload: valor
  };
}
